import { prefersReducedMotion } from '@/helpers/functions'

/**
 * v-reveal — fades an element in the first time it scrolls into view.
 *   <div v-reveal>          fade in on sight
 *   <div v-reveal="120">    same, staggered by 120ms
 * Elements are shown immediately when the visitor prefers reduced motion.
 */

let observer = null

const getObserver = () => {
	if (observer) return observer

	observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return
				entry.target.classList.add('is-in')
				observer.unobserve(entry.target)
			})
		},
		{ rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
	)

	return observer
}

export const revealDirective = {
	mounted(element, binding) {
		if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
			element.classList.add('reveal', 'is-in')
			return
		}

		element.classList.add('reveal')

		const delay = Number(binding.value) || 0
		if (delay) element.style.transitionDelay = `${delay}ms`

		getObserver().observe(element)
	},

	unmounted(element) {
		if (observer) observer.unobserve(element)
	}
}

export default {
	install(app) {
		app.directive('reveal', revealDirective)
	}
}
